// Especialidades cadastradas no banco (GET /packages/especialidades).
import { useEffect, useState } from "react";
import { useApi } from "./useApi";
import { showError } from "../lib/feedback";
import { Especialidade, packagesService } from "../services/packages";

export function useEspecialidades(): Especialidade[] {
  const { apiFetch } = useApi();
  const [especialidades, setEspecialidades] = useState<Especialidade[]>([]);

  useEffect(() => {
    packagesService.especialidades(apiFetch)
      .then(setEspecialidades)
      .catch((err) => showError(err));
  }, [apiFetch]);

  return especialidades;
}
